import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

import { useBreadcrumbs } from "fond/projects/Breadcrumbs/hooks/useBreadcrumbs";
import { Store } from "fond/types";

import { CrumbedChip, Crumbs } from "./breadcrumbs.styles";

const SharedBreadcrumbs: React.FC = () => {
  const navigate = useNavigate();
  const { reverseAncestors } = useBreadcrumbs();
  const userEmail = useSelector((state: Store) => state.cognito.user?.username);

  // ancestors without permissions does not get returned by the folder
  const firstSharedFolder = reverseAncestors.findIndex((ancestor) => ancestor.Creator !== userEmail);
  // remove any ancestors above the first shared folder from breadcrumbs
  const sharedAncestors = firstSharedFolder !== -1 ? reverseAncestors.slice(firstSharedFolder) : reverseAncestors;

  const handleSharedClick = () => {
    navigate("/shared");
  };

  return (
    <Crumbs>
      <CrumbedChip label="Shared with me" onClick={handleSharedClick} />
      {sharedAncestors.slice(0, -1).map((folder) => (
        <CrumbedChip key={folder.ID} label={folder.Name} onClick={() => navigate(`/folders/${folder.ID}`)} />
      ))}

      {!!sharedAncestors.length && <CrumbedChip label={reverseAncestors[reverseAncestors.length - 1].Name} />}
    </Crumbs>
  );
};

export default SharedBreadcrumbs;
